module.exports = __webpack_public_path__ + "static/photo-e257a9255acf22cae851431d44dd7f9b.jpg";